import {Component, DestroyRef, OnInit, inject, input, model, output, ChangeDetectionStrategy} from "@angular/core"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"
import {MatDialog} from "@angular/material/dialog"
import {ActivatedRoute, Params, Router} from "@angular/router"
import {AuthService} from "@common/services/auth/auth.service"
import {FilterNameType} from "@common/services/filters/filters.service"
import {Enums} from "@enums"
import {Dictionary, UtilsService} from "@legacy/helpers/utils"
import {debounceTime, distinctUntilChanged, Subject} from "rxjs"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-item-filters",
    templateUrl: "./item-filters.component.html",
    styleUrls: ["./item-filters.component.scss"],
})
export class ItemFiltersComponent implements OnInit {
    readonly $optionalFilters = input<(FilterNameType | "search")[]>([], {alias: "optionalFilters"})
    readonly $stateFilter = input<FilterNameType | "search">(undefined, {alias: "stateFilter"})
    readonly filterChange = output<Dictionary<string>>()

    readonly $filter = model<Dictionary<string>>({}, {alias: "filter"})

    public readonly Enums = Enums
    searchTextChanged = new Subject<string | MouseEvent>()

    private optionalFiltersSet = new Set<FilterNameType | "search">()

    readonly destroyRef = inject(DestroyRef)
    readonly dialog = inject(MatDialog)
    private readonly router = inject(Router)
    private readonly route = inject(ActivatedRoute)
    readonly auth = inject(AuthService)
    readonly utils = inject(UtilsService)

    filterChanged(): void {
        this.applyFiltersToQueryParams(this.$filter())
    }

    applyQueryParamsToFilters(params: Params) {
        this.$filter.set(this.utils.paramsToDictionary(params))
        this.filterChange.emit(this.$filter())
    }

    applyFiltersToQueryParams(dictionary: Dictionary<string>) {
        const params = this.utils.dictionaryToParams(dictionary)
        void this.router.navigate([], {relativeTo: this.route, queryParams: params})
    }

    ngOnInit(): void {
        this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((queryParams: Params) => this.applyQueryParamsToFilters(queryParams))
        this.optionalFiltersSet = new Set(this.$optionalFilters() ?? [])
        this.searchTextChanged.pipe(takeUntilDestroyed(this.destroyRef), debounceTime(500), distinctUntilChanged()).subscribe(() => this.filterChanged())
    }

    showFilterType(type: FilterNameType | "search"): FilterNameType | "search" | null {
        return this.optionalFiltersSet.has(type) ? type : null
    }
}
